export default __webpack_public_path__ + "images/69.27b6cba.png";